import React from 'react';
import Header from './components/Header.js';
import MainContent from './components/MainContent.js';
import PortfolioDetails from './components/PortfolioDetails.js';
import Contact from './components/Contact.js';
import Footer from './components/Footer.js';
import Phobox from './components/Phobox.js';
import logo from './logo.svg';
import { BrowserRouter, Route } from 'react-router-dom'

import './App.css';


function App() {
  return (
    <div>
      <Header />
      <MainContent />
      <PortfolioDetails
        details={{
          id: 'lastMageStandingPopup', title: "LAST MAGE STANDING",
          media: <div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="https://www.youtube.com/embed/Fe93fLNbF1w" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>,
          content: <div><p>I was the lead game developer on the innovative gesture based HTML5 game The Last Mage Standing.</p>
          <p>The game allows players to control their mage on a platform and the aim is to try to knock your opponent off into the fiery surroundings before they do the same to you. Players make use of predetermined gestures to collect mana and then cast spells. The spells can be used to select an element, cast a protective shield, or fire a missile towards the opponent. </p>
          <p>The game is playable on any browser, desktop or mobile, as long as a camera is available. The camera picks up the users actions and allows the user to play the game through simple gestures, without the need for a controller or any other hardware.</p>
          <p>The game was developed in Phaser3, coded from scratch in Javascript ES6, and leverages the Google Tensorflow machine learning framework for gesture recognition, and the Photon multiplayer server to facilitate two player online battles.</p></div>
        }} />
      <PortfolioDetails
        details={{
          id: 'slotGamesPopup', title: "HTML5 SLOT GAMES",
          media: <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img class="d-block w-100" src="img/portfolio/image12.png" alt=""></img>
              </div>
              <div class="carousel-item">
                <img class="d-block w-100" src="img/portfolio/image13.png" alt=""></img>
              </div>
              <div class="carousel-item">
                <img class="d-block w-100" src="img/portfolio/image14.png" alt=""></img>
              </div>
              <div class="carousel-item">
                <img class="d-block w-100" src="img/portfolio/image15.png" alt=""></img>
              </div>
              <div class="carousel-item">
                <img class="d-block w-100" src="img/portfolio/image16.jpeg" alt=""></img>
              </div>
            </div>
            <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
          </div>,
          content: <div>	<p>I have been very proficient in the creation of HTML5 products. There are lots of advantages of using HTML5, but the main upside is that, when done well, it works on most devices and platforms. </p>
            <p>I was a member of the development team for rewriting various Cross-platform Flash gambling games for HTML5, and developing new HTML5 games using the "Phaser" HTML5 Game Framework. These games, while top quality, are compatible with both desktop and mobile devices, and playable through a simple click of a web link. </p>
            <p>I am responsible for developing both the main game and the bonus games for various HTML5 casino games, as well as adapting the client API interfaces to integrate with the online casino servers.</p></div>
        }} />

      <PortfolioDetails
        details={{
          id: 'phoboxPopup', title: "PHOBOX",
          media:<div id="carouselExampleControls1" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner">										
            <div class="carousel-item active">
            <img class="d-block w-100" src="img/portfolio/image8.jpeg" alt=""></img>
            </div>
            <div class="carousel-item">
            <img class="d-block w-100" src="img/portfolio/image9.jpeg" alt=""></img>
            </div>
            <div class="carousel-item">
            <img class="d-block w-100" src="img/portfolio/image10.png" alt=""></img>
            </div>
          </div>
        <a class="carousel-control-prev" href="#carouselExampleControls1" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls1" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
        </div>,
          content: <div>	<p>Phobox is a VR phobia treatment program developed in partnership with an expert in this field, and makes use of real video footage to create a more realistic experience for the patients. It has been clinically proven to successfully help patients overcome their phobias.</p>
            <p>The aim of Phobox is that while patients face the phobia with the aid of a realistic video in VR glasses, the doctor observes the patient's reactions by watching the patients view on their own computer screen. Unity Game Engine was used for developing this program and I was a member of the development team working on both client-side and server-side. She was responsible for: </p>
            <p>- Managing the database that stores doctors’ and patients’ information with MongoDB.</p>
            <p>- Providing communication between the server and the user interface for storing or retrieving data processes.</p>
            <p>- Developing an admin panel for uploading or deleting new phobia videos which can be seen on both the patient’s VR device and the doctors screen.</p></div>
        }} />

      <PortfolioDetails details={{
        id: 'poseplayPopup', title: "POSEPLAY.TECH",
        media: <img className="d-block w-100" src="img/portfolio/poseplayTech.png" alt=""></img>,
        content: <div><p>PosePlay.Tech is an online platform that tracks the latest news regarding pose and gesture recognition based AI technology.</p>
          <p>I developed the site, leveraging a Bootstrap template, which I adapted to the clients design, creating a bespoke site. The client did not wish to use an existing CMS system so I also built a Node.JS backend, using a SQL database, to serve the site from a Linux Amazon server.</p></div>
      }} />

      <PortfolioDetails details={{
        id: 'hologramPopup', title: "HOLOGRAMSOFT.COM",
        media: <img className="d-block w-100" src="img/portfolio/Hologram.png" alt=""></img>,
        content: <div><p>Hologramsoft.com is a company website. The client requested to change the existing website with a new one. </p>
          <p>I developed this site, leveraging a Bootstrap template.</p></div>
      }} />

  

      <PortfolioDetails details={{
        id: 'patientShoesPopup', title: "PATIENT SHOES",
        media: <div id="carouselExampleControls2" class="carousel slide" data-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img className="d-block w-100" src="img/portfolio/PS1.png" alt=""></img>
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src="img/portfolio/PS2.png" alt=""></img>
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src="img/portfolio/PS3.png" alt=""></img>
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src="img/portfolio/PS4.png" alt=""></img>
            </div>

          </div>
          <a className="carousel-control-prev" href="#carouselExampleControls2" role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="#carouselExampleControls2" role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>,
        content: <div><p>Patient Shoes is a gesture based experimental desktop application which aims to put people in asthma patients’ shoes. This application uses a body tracking AI system to transfer the user's movements to the model (patient) on the screen, and this model applies the user's movements exactly.
           The user also controls the app via basic gesture movements such as swiping right and left to get information about different patients.</p>								
        <p>I was the lead developer of this project and developed it in the Unity 3D game engine, coded in C# and used the Microsoft Azure Kinect DK Body Tracking SDK and Microsoft Azure Kinect DK Sensor SDK.</p></div>
      }} />

      <PortfolioDetails details={{
        id: 'realEstatePopup', title: "REAL ESTATE VR",
        media: <div id="carouselExampleControls3" class="carousel slide" data-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img className="d-block w-100" src="img/portfolio/image18.png" alt=""></img>
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src="img/portfolio/image19.png" alt=""></img>
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src="img/portfolio/image20.png" alt=""></img>
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src="img/portfolio/image21.png" alt=""></img>
            </div>

          </div>
          <a className="carousel-control-prev" href="#carouselExampleControls3" role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="#carouselExampleControls3" role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>,
        content: <div><p>VR technology has been used in many areas in recent years, and particularly effectively in real estate.</p>								
        <p>I developed an application using the Unity Game Engine for the Samsung Gear VR. The application allows customers who want to rent or buy a residence, to see it and walk around in it without having to go there.</p>								
        <p>When a users wears the VR glasses they find themselves in a specific room or the garden and if they look at any of the visible doors they are transported into that particular location. The product used prerendered 360 images for each room in the property. </p>
        <p>I created this product for Flow Virtual Technologies in 2016, at the time it was one of the first products in the world that achieved this.</p></div>
      }} />

      <PortfolioDetails details={{
        id: 'hubPopup', title: "PWC HUB EXPERIENCE",       
        media: <div class="embed-responsive embed-responsive-16by9"><iframe class="embed-responsive-item" src="img/PwCMatchDay Experience.mp4" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>,
        content: <div><p>PwC Hub Experience is a desktop application which was created to run on big screens for a public event.  It allows users to navigate around a room and interact with certain objects in that room to get some information about certain technologies.</p>
        <p>I worked in the Unity 3D game engine to develop and to optimize high quality game assets for this application.</p></div>
      }} />


      <PortfolioDetails details={{
        id: 'blastArenaPopup', title: "BLAST ARENA",
        media: <img className="d-block w-100" src="img/portfolio/blastArena.png" alt=""></img>,
        content: <div><p>The publishers of the BlastArea HTML5 game wanted to publish their game on mobile app stores, as well as allow it to be playable in the browser.</p>								
        <p>I created a HTML5 container in native Java for Android, and Swift for iOS, and wrapped the HTML5 code into native applications for each platform. I also added the required backend connections and API/SDK systems required for the game.</p>	</div>
      }} />

      <PortfolioDetails details={{
        id: 'nbcuPopup', title: "NBCU",
        media: <div id="carouselExampleControls4" class="carousel slide" data-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img className="d-block w-100" src="img/portfolio/NBCU.png" alt=""></img>
            </div>
            <div className="carousel-item">
              <img className="d-block w-100" src="img/portfolio/nbcu2.png" alt=""></img>
            </div>

          </div>
          <a className="carousel-control-prev" href="#carouselExampleControls4" role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="#carouselExampleControls4" role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>,
        content: <div><p>NBCU is a native IOS mobile application which aims to show high resolution videos of some old movies and TV series to a specific audience group.</p>	
        <p>I developed this app in XCode, coded from scratch in Swift. I have created a custom video player from the very beginning for this application and optimized it.
        </p></div>
      }} />

        {/* <PortfolioDetails details={{
        id: 'heroPopup', title: "Hero",
        media: <img className="d-block w-100" src="img/portfolio/hero1.png" alt=""></img>,
        content: <div><p>I developed the physics engine and goalkeeper reaction AI for the football game with the working title "Hero".</p>	
        <p>I built a physics simulation  object that predicts the physics scenario, and evaluates all the possible actions that can be taken by the goalkeeper to best stop the strikers shot. The goalkeepers animations are then triggered in a process that will bring about the best possible outcome for the goalkeeper.
        </p> <p>The task involved a high degree of physics programming, a state machine driven AI system, evaluation of animations that best represent the AI decision, and the integration of all three of these systems, to create an intelligent goalkeeper.</p>
        </div>
      }} />  */}

        <PortfolioDetails details={{
        id: 'saPopup', title: "SACA",
        media: <div id="carouselExampleControls5" class="carousel slide" data-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="d-block w-100" src="img/portfolio/StarAtlas1.png" alt=""></img>
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src="img/portfolio/StarAtlas2.png" alt=""></img>
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src="img/portfolio/StarAtlas3.png" alt=""></img>
          </div>

        </div>
        <a className="carousel-control-prev" href="#carouselExampleControls5" role="button" data-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href="#carouselExampleControls5" role="button" data-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="sr-only">Next</span>
        </a>
      </div>,
        content: <div><p>Start Atlas Companion Application is a native mobile application which is developed as a companion app for a video game.</p>	
        <p>It aims to encourage users to exercise for upgrading their NFT assets in blockchain for the original game.
        </p> <p>I was the lead developer in this project and coded this application from scratch in Swift. </p>
        </div>
      }} />



      {/* <Contact/> */}
      <Footer />
    </div>

  );
}

export default App;
